import { http } from "@/http";

export default {
  list(params) {
    return http.get("/api/v1/admin/brand", { params });
  },
  get(id) {
    return http.get(`/api/v1/admin/brand/${id}`);
  },
  save(payload) {
    return http.post("/api/v1/admin/brand", payload);
  },
  update(id, payload) {
    return http.put(`/api/v1/admin/brand/${id}`, payload);
  },
  toggleStatus(id, isActive) {
    return http.put(`/api/v1/admin/brand/${id}/status`, null, {
      params: {
        isActive
      }
    });
  },
  delete(id) {
    return http.delete(`/api/v1/admin/brand/${id}`);
  },
  listActive() {
    return http.get("/api/v1/admin/brand/all");
  },
  download(params) {
    return http.get('/api/v1/admin/brand/xlsx', {
      responseType: 'blob',
      params
    })
  }
};
